import React from "react";

import starImg from "../assets/star-slash.svg";
import Button from "./Button";

function ModalCancel({ closeModal }) {
    return (
        <div className=' fixed  z-10'>
            <div className='fixed w-full h-full inset-0 bg-black bg-opacity-50 backdrop-blur-sm'></div>
            <div className='fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-white rounded-[16px] p-[16px] w-[316px] '>
                <div className='flex justify-center flex-col'>
                    <img
                        className='w-[54px] m-auto mb-[10px]'
                        src={starImg}
                        alt=''
                    />
                    <p className='text-[#1890FF] text-[16px] font-[600]'>
                        Бронирование отменено
                    </p>
                    <p>
                        Спасибо, что отменили бронь заранее. Будем ждать вас
                        снова
                    </p>
                </div>

                <div onClick={closeModal}>
                    <Button>На главную</Button>
                </div>
            </div>
        </div>
    );
}

export default ModalCancel;
